<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span
                class="fa fa-user-o"></span>{{ 'general.my_profile_form.tfaprofilesetup' | translate}}</div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <p-card>
                <h2>Step 1</h2>
                <p>Using the Google Authenticator app, you should scan the following QR code:</p>
                <div class="qr-container">
                    <img [src]="qrInfo" style="height: 250px; margin-bottom:1rem;"/>
                </div>

                <p>Alternatively, you may enter the following code to the Google Authenticator app:</p>
                <h3 class="manual-entry-code">{{authenticatorKey}}</h3>
            </p-card>
        </div>

        <div class="col-md-6">
            <p-card>
                <h2>Step 2</h2>

                <form [formGroup]="tfaForm" (ngSubmit)="enable2FA(tfaForm.value)">
                    <div class="">
                        <label for="code" class="col-form-label">
                            Enter here the code provided by the Google Authenticator app:
                        </label>
                        <input type="text" id="code" formControlName="code" class="form-control"/>
                        <em *ngIf="validateControl('code') && hasError('code', 'required')">
                            Code is required
                        </em>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <button type="submit" pButton class="p-button-raised accent mt-3"
                                    [disabled]="!tfaForm.valid || isBusy"
                                    label="Enable Two-Factor Authentication"></button>
                        </div>

                        <div class="col-md-6">

                        </div>
                    </div>

                    <div *ngIf="showError" class="alert alert-danger" role="alert" style="margin-top:16px;">
                        {{errorMessage}}
                    </div>
                </form>
            </p-card>
        </div>
    </div>

</div>
